import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'
import { HttpMethod } from '../../../services/core'

const resource = 'images'
const verb = HttpMethod.POST

export default class OspreyImagesShareToAffiliations extends BaseAction {
    constructor(dataKey) {
        const id = '60bac4d5-17cd-482f-bd0e-ee16f0d425b2'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    shareToAffiliations(params) {
        const { imageId, affiliationIdList } = params

        this.path = `/${resource}/${imageId}/share/affiliations`

        this.params = {
            affiliationIdList
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/images/images-affiliations-share.js